(function($) {
	$.fn.refresh = function() {
		var elems = $(this.selector);
		this.splice(0, this.length);
		this.push.apply( this, elems );
		return this;
	};
		
	$.fn.ob_loading = function() {
			var select = this;
			if (select.css('position') == 'static' ){
				select.css('position','relative');
			}
			if (!select.children('.loading_overlay').length ){
				select.prepend('<div class="loading_overlay">\
											<div class="loading_content">\
												<div class="loading_text"></div>\
											</div>\
										</div>');
				
			}
			if ( select.is( "body" ) ) {
				select.find('.loading_overlay').addClass( "full" );
			}
	
	};
	
	$.fn.ob_stop_loading = function() {
			//this.children('.loading_overlay').remove();
			$('.loading_overlay').remove();
	};
	
	$.fn.exist = function() {
		return this.length
	};
	

}(jQuery));



function get_url_arg(){
	// This function is anonymous, is executed immediately and 
	// the return value is assigned to QueryString!
	var query_string = {};
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		// If first entry with this name
		if (typeof query_string[pair[0]] === "undefined") {
			query_string[pair[0]] = decodeURIComponent(pair[1]);
		// If second entry with this name
		} else if (typeof query_string[pair[0]] === "string") {
			var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
			query_string[pair[0]] = arr;
			// If third or later entry with this name
		} else {
			query_string[pair[0]].push(decodeURIComponent(pair[1]));
		}
	} 
	return query_string;

}